// extracted by mini-css-extract-plugin
export default {"popper":"Tooltip_style__popper___dc"};